import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FormValidatorService } from '../fi-services/form-validator.service';
import { Subject } from 'rxjs';
import { NgModel } from '@angular/forms';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { takeUntil } from 'rxjs/operators';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { isDefined } from '@fi-shared/utils';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';

@Component({
    selector: 'fi-edit-tabs',
    templateUrl: './edit-tabs.component.html',
    styleUrls: ['./edit-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-edit-tabs' },
    providers: [{ provide: FiComponentsContainer, useExisting: EditTabsComponent }],
    standalone: false,
})
export class EditTabsComponent extends FiComponentsContainer implements OnInit, OnDestroy {
    @Input() editTabsSettings;
    @Input() isNewHeaderLayout: boolean = false;
    @Input() editorPageContent: HTMLElement;
    @Input() moreMenuItems: MoreMenuMobileSettingsModel;
    @Output() save = new EventEmitter();
    @Output() saveClick = new EventEmitter();
    @Input('selectedIndex') SelectedIndex = 0;
    @Input() showHeader: boolean = true;
    @Input() containerClass: string | string[];

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
        private formValidatorService: FormValidatorService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.formValidatorService
            .onSectionPageValidate()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => {
                this.checkPageSectionError();
            });
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    SelectTab(index: number): void {
        this.SelectedIndex = index;
    }

    checkPageSectionError(): void {
        this.editTabsSettings.Tabs.forEach((tab, index: number) => {
            tab.error =
                document.getElementById(`TabContent-${index}`).querySelectorAll('.ValidationInputError.ng-invalid')
                    .length > 0;
        });
    }

    onSave(): void {
        this.save.emit();
    }

    onValidateError(inputsWithErrors: NgModel[]): void {
        const valueAccessors = inputsWithErrors.map((ngModel) => ngModel.valueAccessor);
        const accessRightFiltersComponent = valueAccessors.find((item) => item instanceof AccessRightFiltersComponent);

        let errorMessage = this.appTextService.get('common.error_all_mandatory');
        if (accessRightFiltersComponent && accessRightFiltersComponent instanceof AccessRightFiltersComponent) {
            errorMessage = accessRightFiltersComponent.getErrorMessage();
        }

        this.fiDialogsService.notify({
            messageText: errorMessage,
            headerText: this.appTextService.get('common.warning'),
        });
    }

    isMobileMenuShown(): boolean {
        return isDefined(this.moreMenuItems) && !!this.moreMenuItems.ListItems.length;
    }

    onHeaderSaveButtonClick(editForm: FiValidatingFormDirective) {
        this.saveClick.emit();
        editForm.submit(this);
    }
}
